import { Checkbox } from 'src/registry/ui/Checkbox';

import type { CellContext } from '@tanstack/react-table';

export function CellCheckbox<TData, TValue>({ row }: CellContext<TData, TValue>) {
    return (
        <Checkbox
            checked={row.getIsSelected()}
            onCheckedChange={(value) => row.toggleSelected(!!value)}
            onClick={(e) => {
                e.stopPropagation();

                const customEvent = new CustomEvent('row-checkbox-click', {
                    detail: { rowIndex: row.index, shiftKey: e.shiftKey, checked: !row.getIsSelected(), rowId: row.id },
                });

                window.dispatchEvent(customEvent);
            }}
            className="size-4 cursor-pointer"
        />
    );
}
